import { Controller } from "@hotwired/stimulus"

// Live countdown to the lanparty.
//
//   <div data-controller="countdown" data-countdown-target-time-value="2027-04-23T18:00:00+02:00">
//     <span data-countdown-target="hours" style="--value: 6">06</span> …
//   </div>
//
// The rolling digits are pure CSS (see landing.scss): this only updates the
// `--value` custom property and the element's text. Values are rendered
// server-side too, so the countdown is correct before and without JavaScript.
export default class extends Controller {
    static targets = ["days", "hours", "minutes", "seconds"]
    static values = { targetTime: String }

    connect() {
        this.deadline = new Date(this.targetTimeValue).getTime()

        if (!Number.isFinite(this.deadline)) return

        this.tick()
        this.timer = setInterval(() => this.tick(), 1000)
    }

    disconnect() {
        clearInterval(this.timer)
    }

    tick() {
        const remaining = Math.max(0, Math.floor((this.deadline - Date.now()) / 1000))

        this.write("days", Math.floor(remaining / 86400))
        this.write("hours", Math.floor((remaining % 86400) / 3600))
        this.write("minutes", Math.floor((remaining % 3600) / 60))
        this.write("seconds", remaining % 60)

        if (remaining === 0) clearInterval(this.timer)
    }

    write(unit, value) {
        if (!this[`has${unit[0].toUpperCase()}${unit.slice(1)}Target`]) return

        const el = this[`${unit}Target`]
        const text = String(value).padStart(2, "0")
        if (el.textContent.trim() === text) return // nothing changed

        el.textContent = text
        el.setAttribute("aria-label", `${value} ${el.nextElementSibling?.textContent.trim() ?? unit}`)
        // Drives the CSS roll; ignored by units rendered without it (days).
        el.style.setProperty("--value", value)
    }
}
